import { render } from "./subpackage-input-fields.vue?vue&type=template&id=9d80e9ec"
import script from "./subpackage-input-fields.vue?vue&type=script&lang=js"
export * from "./subpackage-input-fields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__